import React, { PropsWithChildren, useState } from 'react'
// Local
import Icon from './icon'
import If from '../common/if'
import ChevronDown from '../icons/chevronDown'
import { EncounterConditionDisplayModified } from '../authenticated/types'
import { shouldRenderReskin2025 } from '../../constant'

type Props = {
  id: string
  title: string
  isDown?: boolean
  isTopLevel?: boolean
  isAddressed?: boolean
  isRequired?: boolean
  clinicalConditions?: EncounterConditionDisplayModified[]
}

function Accordion(props: PropsWithChildren<Props>): JSX.Element {
  const {
    id,
    title,
    children,
    isDown: isDownProp = false,
    isTopLevel = false,
    isAddressed = false,
    isRequired = false,
    clinicalConditions = []
  } = props

  const [
    isDown,
    setIsDown
  ] = useState<boolean>(isDownProp)

  function onClick(event: any): void {
    if (isTopLevel) {
      event.stopPropagation()
      setIsDown(!isDown)
    }
  }

  const topLevelClassName = isTopLevel
    ? 'top-level'
    : 'nested'

  const reskinClassName = shouldRenderReskin2025
    ? ' reskin'
    : ''

  const downClassName = isDown
    ? ' is-down'
    : ''

  return (
    <div
      className={
        `curation-ui-accordion-${topLevelClassName}${downClassName}${reskinClassName}`
      }
      id={ id }
    >
      <div
        className={ `accordion-title-container${shouldRenderReskin2025 ? ' reskin' : ''}` }
        onClick={ onClick }
      >
        <If isTrue={ !isTopLevel }>
          <Icon isAddressed={ (clinicalConditions
            && (clinicalConditions.length > 0)
            && (clinicalConditions.filter(c => c.isAddressed).length > 0))
            || isAddressed }
          isRequired={ isRequired }
          />
        </If>
        <div className={ `accordion-title${shouldRenderReskin2025 ? ' reskin' : ''}` }>
          { title }
        </div>
        <If isTrue={ isTopLevel }>
          <div
            className={ `curation-ui-chevron-container${isDown ? ' is-down' : ''
            }` }
            onClick={ onClick }
          >
            <ChevronDown />
          </div>
        </If>
      </div>
      <div className="accordion-content">{ children }</div>
    </div>
  )
}

export default Accordion
